import React, { useContext, useState } from 'react';
import { HeadingContext } from '../context/HeadingContext'; // Importing HeadingContext from context folder
import Dropdown from 'react-bootstrap/Dropdown'; // Importing Dropdown component from react-bootstrap
import Auth from '../../auth/Auth'; // Importing Auth module for authentication
import { useNavigate } from 'react-router-dom'; // Importing useNavigate hook from react-router-dom
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { logOut } from '../_slice/onboardingSlice';
import AppContext from '../context/AppContext';
import CustomModal from '../widgets/CustomModal';
import hamburgerImage from "../../assets/images/menuToggle.png"

function Header({ sideBarHandler, isMobile }) {

  const location = useLocation();
  const isProfilePage = location.pathname === '/profile';

  const [modalShow, setModalShow] = useState(false)
  // Using useContext hook to access the value of heading from HeadingContext
  const { heading } = useContext(HeadingContext);
  const navigate = useNavigate(); // Using useNavigate hook for programmatic navigation
  // const userName = useSelector((state) => state?.organization?.organizationData?.first_name + ' ' + state?.organization?.organizationData?.last_name); // Using useNavigate hook for programmatic navigation

  // Get both data sources
  const organizationData = useSelector((state) => state?.organization?.organizationData);
  const profileData = useSelector((state) => state.user.profileData || {});

  // Conditional user name
  const userName = isProfilePage
    ? `${profileData.first_name || ''} ${profileData.last_name || ''}`.trim()
    : `${organizationData?.first_name || ''} ${organizationData?.last_name || ''}`.trim();

  const dispatch = useDispatch();
  const { setLoader } = useContext(AppContext)

  // Function to handle logout
  const logout = () => {
    dispatch(logOut({ setLoader }));
    Auth.logout(); // Call logout method from Auth module to clear authentication
    navigate('/'); // Redirect to the home page after logout
  }

  const handleProfileClick = () => {
    navigate('/profile'); // Navigate to profile page
  };

  // let { innerWidth } = window;
  // console.log('userName', userName);

  return (
    <>
      <div className='header'>
        <div className='header_breadcrumb'>
          {isMobile && <img
            src={hamburgerImage}
            alt="hamburger"
            className="cursor mr-3"
            onClick={sideBarHandler}
          />}
          {heading} {/* Display the value of heading in the header */}
        </div>
        <div className='d-flex align-items-center'>
          <div className='header_profile mr-3'>
            <p className='header_profile_text text-capitalize'>
              {userName}
            </p>
            {/* <div className='header_profile_pic'>
              <span className='count'>12</span>
              <img src={profilePic} alt='' />
            </div> */}
          </div>
          {/* Dropdown component for user options */}
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              {/* Icon for the dropdown */}
              <svg width="4" height="20" viewBox="0 0 4 20" fill="none">
                <path d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z" fill="#004D26" />
                <path d="M2 12C3.10457 12 4 11.1046 4 10C4 8.89543 3.10457 8 2 8C0.89543 8 0 8.89543 0 10C0 11.1046 0.89543 12 2 12Z" fill="#004D26" />
                <path d="M2 20C3.10457 20 4 19.1046 4 18C4 16.8954 3.10457 16 2 16C0.89543 16 0 16.8954 0 18C0 19.1046 0.89543 20 2 20Z" fill="#004D26" />
              </svg>
            </Dropdown.Toggle>
            {/* Dropdown menu with logout option */}
            <Dropdown.Menu>
              <Dropdown.Item className='logout_btn' onClick={handleProfileClick}>Profile</Dropdown.Item>
              <Dropdown.Item className='logout_btn' onClick={() => setModalShow(true)}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <CustomModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        // heading="Delete Campus"
        size="md"
        body={
          <div className='deleteModal'>
            <p className='text-center mb-5'>Are you sure, you want to logout?</p>
            <div className='d-flex justify-content-between align-items-center custom_bottom_padding'>
              <button type='button' className='submit_btn' onClick={logout}>Yes</button>
              <button type='button' className='cancleBtn' onClick={() => setModalShow(false)}>No</button>
            </div>
          </div>
        }
      />
    </>
  );
}

export default Header; // Exporting the Header component